module.exports = __webpack_public_path__ + "img/hp.ac3ecce6.jpeg";